import { useContext } from 'react';

import { SCard } from 'app/components/StaycationUI';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { OvernightRuleField } from './_components/OvernightRuleField/OvernightRuleField';

const PAGE_TITLE = 'Overnight rule';
const PAGE_SUBTITLE =
  'Define when an always-included activity should be highlighted on the hotel page.';

export const OvernightRule = () => {
  const { isViewMode } = useContext(ViewEditModeContext);

  return (
    <SCard
      title={PAGE_TITLE}
      subtitle={PAGE_SUBTITLE}
      className="experience-form overnight-rule"
    >
      <FormLineLayout
        label="Always included overnight"
        hideDescriptionIcon
        description={
          <ul className="overnight-info">
            <li>
              This will appear in the "Always Included" section on the hotel
              page.
            </li>
            <li>
              Apply this only to free areas and facilities available to all
              overnight guests, except for F&B.
            </li>
          </ul>
        }
      >
        <OvernightRuleField
          name="isAlwaysIncludedWithNight"
          disabled={isViewMode}
        />
      </FormLineLayout>
    </SCard>
  );
};
